import { observer } from "mobx-react-lite";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../../mst/stores/mk8s.draft";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateProviderGenericNodePoolAddRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (isDone) {
      navigate(
        `${pathname.replace("-add", "")}${
          mk8sDraft.provider_generic.nodePools[mk8sDraft.provider_generic.nodePools.length - 1].index
        }`
      );
      return;
    }

    mk8sDraft.provider_generic.addNodePool();
    setIsDone(true);
  }, [isDone]);

  return null;
};

export const Mk8sCreateProviderGenericNodePoolAdd = observer(Mk8sCreateProviderGenericNodePoolAddRaw);
